import { gql } from 'urql';

export const resetPasswordTokenStatus = gql`
  query ResetPasswordTokenStatus($token: String!) {
    resetPasswordTokenStatus(token: $token)
  }
`;
